import {_SegurancaEndpoints} from "@localization/siteMap/endpoints/_SegurancaEndpoints.js";
import type {IPermissao} from "@models/seguranca/permissaoApp.js";
import React from "react";
import {DefaultConsumerPesquisaAutoProps, DefaultPesquisaAuto} from "@shared/specialComponents/DefaultPesquisaAuto.tsx";
import {IDataDto} from "@models/shared/IDataDto.ts";


interface RolesPesquisaProps extends DefaultConsumerPesquisaAutoProps<IPermissao, { search: string }> {

}

export function PermissoesPesquisa(props: RolesPesquisaProps) {
    const {onItemSelected} = props;
    const handleItemSelected = (item?: IPermissao) => {
        if (onItemSelected) {
            onItemSelected(item);
        }
    };

    const formataPermissao = (permissao: IPermissao) => `${permissao.nome}`;

    return (
        <DefaultPesquisaAuto<IPermissao, { search: string }>
            endpoint={(data: IDataDto<{
                search: string
            }>) => {
                return _SegurancaEndpoints.getPermissoesPesquisa(data.data.search, data.pagination)
            }}
            searchField={'search'}
            itemToString={formataPermissao}
            onItemSelected={handleItemSelected}
            display={{
                name: "Permissoes"
            }}
        />
    );
};

